import * as React from "react";
import type { SVGProps } from "react";
const SvgMessageSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m6.678 21.6 5.009-5.009H19.6a2 2 0 0 0 2-2V4.4a2 2 0 0 0-2-2H4.4a2 2 0 0 0-2 2v10.191a2 2 0 0 0 2 2h2.278z"
    />
  </svg>
);
export default SvgMessageSquare;
